import { render, staticRenderFns } from "./LabelsView.vue?vue&type=template&id=37e67e72&scoped=true"
import script from "./LabelsView.vue?vue&type=script&lang=ts"
export * from "./LabelsView.vue?vue&type=script&lang=ts"
import style0 from "./LabelsView.vue?vue&type=style&index=0&id=37e67e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e67e72",
  null
  
)

export default component.exports